import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import TextField from '@material-ui/core/TextField';
import { Grid, Link, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(() => ({
    monthSelector: {
        '& input': {
            marginTop: '-3px',
            width: '58px',
            fontSize: '12px',
        }
    }
}))

export default function CustomMonthYearPicker({ value, handleChange }) {
    const classes = useStyles()
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
                views={['year', 'month']}
                maxDate={new Date()}
                value={value}
                onChange={(newValue) => {
                    handleChange(newValue);
                }}
                className={classes.monthSelector}
                renderInput={(params) => <TextField {...params} helperText={null} />}
            />
        </MuiPickersUtilsProvider>
    );
}
